import { Link } from "react-router-dom"
import Input from "../../blocks/Input"
import { useForm } from "../../hooks/useForm"
import './header.css'
import OfficeModal from "../Modals/Office-filter-modal"
import { useRef, useState } from "react"
import context from "../../scripts/context"



const OfficesHeader = ({onFilter, count}) => {

    const officeModal = useRef()
    const [inputs, setInputs] = useState(context.getOfficeInputFilter())
    const onOfficeInputFilter = (ins) => {
        setInputs({
            ...ins
        })
    }


    context.addListenerOfficeInputFilter((ins)=>{onOfficeInputFilter(ins)})

    const openModal = () => officeModal.current.openModal()

    const handleSearchChange = (value, code)=>{
        const ni = {
            ...inputs,
            [code]: {
                ...inputs.code,
                value: value
            },
        }
        setInputs(ni)
        context.setOfficeInputFilter(ni)
    }

    const checkEnter = (event) => {
        if (event.keyCode === 13) {
            onFilter(inputs)
        }
    };

    return(

        <div className="searchbar">
            <div className="searchbar__input">
                <Input inputField={inputs.code} onChange={handleSearchChange} onKeyDown={e => checkEnter(e)} />
            </div>
            <div className="searchbar__filter">
                <button onClick={openModal}>Filter {(count!== 0 ? <span>{count}</span> : '')}</button>
            </div>
            <div className="searchbar__btn">
                <Link to={"/agent/offices/detail"} state={'create'} >
                    <button> + Add New Office</button>
                </Link>
            </div>
            <OfficeModal ref={officeModal} onFilter={(inputs) => {setInputs(inputs); onFilter(inputs);}} />
        </div>
    )
}
export default OfficesHeader

